import { jsx as _jsx } from "react/jsx-runtime";
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { Data } from '../signup-data/DATA';
import { DataOptions } from '../signup-data/signupDataOptions';
import { BaseButtonsView } from './BaseButtonsView';

const CrmExperienceLevelView = () => {
  const options = DataOptions[Data.CrmExperienceLevel];
  useExperiment(ExperimentKeys.BIAB004, TrackWhen.assignedToControl, true);
  useExperiment(ExperimentKeys.GOSU0001, TrackWhen.enrolled, true);
  return /*#__PURE__*/_jsx(BaseButtonsView, {
    options: options
  });
};

export default CrmExperienceLevelView;